module.exports = __webpack_public_path__ + "loader-9e8fb53dc2d13da643bc.svg";